import { Link } from 'react-router-dom';
import { LanguageSwitcher } from '../LanguageSwitcher';
import { Button } from '../ui/button';
import logo from '../../assets/logo-new.png';

function scrollToPlans(event) {
  event.preventDefault();
  const target = document.getElementById('planos');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

export function Hero({ copy, heroImage }) {
  return (
    <section className="relative overflow-hidden bg-blue-600">
      <div className="relative z-10 mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
        <header className="flex flex-col gap-4 rounded-lg  p-4 backdrop-blur sm:flex-row sm:items-center sm:justify-between sm:p-5">
          <Link to="/" className="inline-flex items-center">
            <img src={logo} alt="Isy (Investe Sempre System)" className="h-auto w-36 max-w-full sm:w-40" />
          </Link>

          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end">
            <LanguageSwitcher className="justify-start sm:justify-center" />
          </div>
        </header>

        <div className="grid gap-10 py-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,0.95fr)] lg:items-center lg:py-20">
          <div className="max-w-2xl">
            <p className="text-sm font-semibold uppercase tracking-[0.24em] text-blue-100">
              {copy.hero.eyebrow}
            </p>
            <h1 className="mt-5 text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
              {copy.hero.title}
            </h1>
            <p className="mt-6 max-w-xl text-base leading-8 text-white/90 sm:text-lg">
              {copy.hero.description}
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Button asChild size="lg" className="bg-white text-blue-700 hover:bg-blue-50">
                <a href="#planos" onClick={scrollToPlans}>
                  {copy.hero.primaryCta}
                </a>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-white/20 bg-white/10 text-white hover:bg-white/20 hover:text-white"
              >
                <Link to="/signin">{copy.hero.secondaryCta}</Link>
              </Button>
            </div>

          </div>

          <div className="relative flex items-center justify-center">
            <div className="w-full max-w-[620px] rounded-lg border border-white/15 bg-white p-1.5 shadow-xl shadow-slate-950/20">
              <img
                src={heroImage.src}
                alt={heroImage.alt}
                className="h-auto w-full rounded-md object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="pointer-events-none absolute bottom-0 left-0 h-80 w-full bg-[linear-gradient(to_bottom,rgba(37,99,235,0)_0%,rgba(37,99,235,0.08)_24%,rgba(37,99,235,0.22)_46%,rgba(37,99,235,0.16)_64%,rgba(255,255,255,0.55)_84%,#ffffff_100%)]" />
    </section>
  );
}
